const LoginState = JSON.parse(localStorage.getItem('user')) || {};
export default LoginState;